/** 마크다운 테이블 라인인지 확인 (| 3개 이상, 양 끝 | 필수) */
export const isTableLine = (line: string): boolean => {
  const trimmed = line.trim();
  const pipeCount = (trimmed.match(/\|/g) || []).length;
  return trimmed.startsWith("|") && trimmed.endsWith("|") && pipeCount >= 3;
};

/** 마크다운 테이블 구분선(| :---: | 형태)인지 확인 */
export const isTableSeparator = (line: string): boolean =>
  /^\|[\s]*(:?-+:?[\s]*\|)+[\s]*$/.test(line.trim());

/** 마크다운 테이블을 2차원 배열로 파싱 (구분선 제거, 셀 trim) */
export const parseTableRows = (lines: string[]): string[][] =>
  lines
    .filter((line) => !isTableSeparator(line.trim()))
    .map((line) =>
      line
        .split("|")
        .filter((cell) => cell.trim())
        .map((cell) => cell.trim())
    );